import { createAction, props } from '@ngrx/store';
import { MissedDossiers } from './missed-dossiers.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch record missed dossiers'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch record missed dossiers success', 
    props<{ listData: MissedDossiers[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch record missed dossiers failure', 
    props<{ error: string }>()
);

// Mark AS Handled
export const markHandled = createAction(
    '[Data] Mark handled missed dossier record',
    props<{ id: string }>()
);
export const  markHandledSuccess = createAction(
    '[Data] Mark handled missed dossiers success'
);
export const markHandledFailure = createAction(
    '[Data] Mark handled missed dossiers failure',
    props<{ error: string }>()
);

// Retry Missed Entry
export const retryMissedDossier = createAction(
    '[Data] Retry missed dossier record',
    props<{ id: string }>()
);
export const  retryMissedDossierSuccess = createAction(
    '[Data] Retry missed dossiers success'
);
export const retryMissedDossierFailure = createAction(
    '[Data] Retry missed dossiers failure',
    props<{ error: string }>()
);

//Fetch Count
export const fetchMissedDossiersCount = createAction(
    '[Data] Fetch total count for missed dossiers'
);
export const  fetchMissedDossiersCountSuccess = createAction(
    '[Data] Fetch total count for missed dossiers success'
);
export const fetchMissedDossiersCountFailures = createAction(
    '[Data] Fetch total count for missed dossiers failure',
    props<{ error: string }>()
);


//Reset State
export const resetState = createAction(
    '[Data] reset state missed dossiers',
);